// Action Types for Aurora SQL
export const EXECUTE_AURORA_SQL_REQUEST = "EXECUTE_AURORA_SQL_REQUEST";
export const EXECUTE_AURORA_SQL_SUCCESS = "EXECUTE_AURORA_SQL_SUCCESS";
export const EXECUTE_AURORA_SQL_FAILURE = "EXECUTE_AURORA_SQL_FAILURE";

export const GET_QUERY_BUILDER_SCHEMA_REQUEST =
  "GET_QUERY_BUILDER_SCHEMA_REQUEST";
export const GET_QUERY_BUILDER_SCHEMA_SUCCESS =
  "GET_QUERY_BUILDER_SCHEMA_SUCCESS";
export const GET_QUERY_BUILDER_SCHEMA_FAILURE =
  "GET_QUERY_BUILDER_SCHEMA_FAILURE";

// Execute Aurora SQL Query
export const executeAuroraSqlRequest = (payload) => ({
  type: EXECUTE_AURORA_SQL_REQUEST,
  payload,
});

export const executeAuroraSqlSuccess = (data) => ({
  type: EXECUTE_AURORA_SQL_SUCCESS,
  payload: data,
});

export const executeAuroraSqlFailure = (error) => ({
  type: EXECUTE_AURORA_SQL_FAILURE,
  payload: error,
});

// Get Query Builder Schema
export const getQueryBuilderSchemaRequest = () => ({
  type: GET_QUERY_BUILDER_SCHEMA_REQUEST,
});

export const getQueryBuilderSchemaSuccess = (data) => ({
  type: GET_QUERY_BUILDER_SCHEMA_SUCCESS,
  payload: data,
});

export const getQueryBuilderSchemaFailure = (error) => ({
  type: GET_QUERY_BUILDER_SCHEMA_FAILURE,
  payload: error,
});
